
import {mapActions} from 'vuex';
import sulu from 'razlet-sulu-sdk/lib/mixins/sulu';
import { getSuluApi } from 'razlet-sulu-sdk/lib/utils/helpers';

export default {
  name: 'news-list-page',
  mixins: [sulu],
  async asyncData ({ store, error, redirect }) {
    const result = await getSuluApi({ store, error, redirect, path: `news-list` });
    return {result};
  },
  // data () {
  //   return {
  //     moreLoading: false,
  //   };
  // },
  methods: {
    ...mapActions(['sulu/getApiData']),
  },
};
